//*************************DO NOT MODIFY*************************************
//
//THESE FILES ARE AUTOGENERATED AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//
//*************************DO NOT MODIFY*************************************



export interface ISystemTypeViewModel {
    id?: number;
    name?: string | null;
    disciplineId?: number;
}

export class SystemTypeViewModel implements ISystemTypeViewModel {
    public id: number;
    public name: string | null;
    public disciplineId: number;
}
